/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoginStatuses } from './login-statuses';
import { DeviceInfoDto } from './device-info-dto';


export interface SearchUserLoginHistoryResponseItem { 
    id: string;
    ipAddress: string;
    country?: string | null;
    city?: string | null;
    deviceInfo?: DeviceInfoDto;
    status: LoginStatuses;
    failureReason?: string | null;
    loginAttemptDate: string;
}



